import { ReactNode, useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";

interface IPublicRoute {
  children: ReactNode;
}

export function PublicRoute({ children }: IPublicRoute) {
  const { isAuthenticated } = useContext(AuthContext);

  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated && location.pathname === "/login") {
      const params = new URLSearchParams(location.search);
      const hasLoginParams = params.has("token") || params.has("agent") || params.has("secret") || params.has("tokenItem");
      console.log('PublicRoute: isAuthenticated is true and on /login route');
      if (hasLoginParams) {
        console.log('PublicRoute: Login parameters detected, skipping signOut');
        return;
      }
    }
  }, [isAuthenticated, location]);

  // Allow access to some login routes even when authenticated:
  // - `/login`: allow when login params are present (handled above)
  // - `/login-elbb`: allow always (visual-only login page)
  if (isAuthenticated) {
    if (location.pathname === "/login-elbb") {
      return <>{children}</>;
    }

    // Keep existing behavior for `/login` with params handled in the effect
    const params = new URLSearchParams(location.search);
    const hasLoginParams = params.has("token") || params.has("agent") || params.has("secret") || params.has("tokenItem");
    if (location.pathname === "/login" && hasLoginParams) {
      return <>{children}</>;
    }

    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
